import * as React from 'react';

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgPhoneOutline24 = function SvgPhoneOutline24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.809 23.027c-2.957-.046-6.347-3.545-8.493-8.376-2.145-4.83-2.544-9.89-.64-12.218l2.438-1.145L11.09 5.74 8.716 6.857l-.074.115c-.059.09-1.149 2.883.583 6.783 1.733 3.9 4.43 4.758 4.534 4.772l.135.018 2.375-1.116 1.98 4.453-2.44 1.145zm.927-6.886-2.974 1.395c-.463-.122-2.371-1.246-3.677-4.185-1.308-2.945-.925-5.3-.715-5.733l2.974-1.395L9.581 0 6.187 1.592l-.159.122c-2.253 2.637-1.934 8.023.427 13.342C8.809 20.353 12.474 24 15.875 24h.038l3.587-1.637-2.764-6.222z",
    fill: "currentColor"
  })));
};

var PhoneOutline24Svg = SvgPhoneOutline24;

export { PhoneOutline24Svg as default };
//# sourceMappingURL=PhoneOutline24.svg.js.map
